// Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownButton } from 'react-bootstrap';
import classNames from 'classnames';
// Modules

export class Select extends Component {

    constructor(props) {
        super(props);
        this.toggleBtn = null;
        this.state = {
            isOpen: false
        };
    }

    toggleDropdown(e) {
        e.preventDefault();
        e.stopPropagation();
        const {disabled, readOnly} = this.props;

        if (disabled || readOnly) {
            return;
        }

        const self = this;
        self.toggleBtn.querySelector('button').click();
    }

    handleChange(value, e) {
        const {subscribe} = this.props;

        if (subscribe) {
            subscribe(value);
        }
    }

    onToggle(isOpen) {
        this.setState({
            isOpen
        });
    }

    render() {
        const { id, placeholder, name, required, invalid, value, readOnly, disabled, buttonIcon} = this.props;
        const currentValue = value || placeholder;

        return (
            <div id={id} name={name} className={classNames('formSelect', {invalid, readOnly, disabled})}>
                <div className={classNames('label', {hide: !(this.state.isOpen || value)})}>{this.props.label}</div>
                <div onClick={this.toggleDropdown.bind(this)} className={classNames('form-control', {open: this.state.isOpen, required, placeholder: !(!!value)})}>
                    <div className="input-group">
                        <div className={classNames('currentSelect', { placeholder: !(!!value)})}>{currentValue}</div>
                        <div ref={(elem) => { this.toggleBtn = elem; }} className="input-group-btn">
                            <DropdownButton
                              id={`${id}-btn`}
                              onToggle={this.onToggle.bind(this)}
                              onSelect={this.handleChange.bind(this)}
                              title={buttonIcon || <i className="togo-icon togo-icon-chevron"></i>}
                              disabled={disabled || readOnly}
                              noCaret
                            >
                                {this.props.children}
                            </DropdownButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Select.propTypes = {
    invalid: PropTypes.bool,
    children: PropTypes.array.isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    defaultValue: PropTypes.string,
    subscribe: PropTypes.func,
    disabled: PropTypes.func,
    readOnly: PropTypes.func,
    value: PropTypes.string,
    buttonIcon: PropTypes.element
};

export default Select;




// WEBPACK FOOTER //
// ./src/components/SharedComponents/form/select.js